module.exports = __webpack_public_path__ + "static/media/eugene-placeholder.d101e756.webp";